export const intialStateModificheDetails = {
    ruleName: "",
    logDetailsRows: []
}